module.exports = __webpack_public_path__ + "img/thumb_video.21a55ca5.svg";